import { BaseService } from '../base.service'
import { ErrorWrapper, ResponseWrapper } from '../util'

// Endpoints do push na API Aluno (STORY-1642, contrato da fatia 0, seção 2).
// Todos ignoram o X-ApplicationId: o dono é sempre o aluno do JWT.
export class PushService extends BaseService {
  static get entity () {
    return 'push'
  }

  // PUT /students/devices/{installationId} -> 204. Upsert: reenviado no login,
  // no resume e quando o token muda.
  static async registerDevice (installationId, body) {
    try {
      const response = await this.request({ auth: true }).put(
        `${process.env.VUE_APP_EAD_API_URL}/students/devices/${encodeURIComponent(installationId)}`,
        body
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error, _errorMessage(error));
    }
  }

  // DELETE /students/devices/{installationId} -> 204 (idempotente); 5xx se o banco
  // falhar, e aí o chamador apaga o token local e deixa o desregistro pendente.
  //
  // Roda no LOGOUT, então foge do caminho normal de propósito:
  //   - sem o interceptor de refresh (`auth: false`): no `clearToLogin` a sessão
  //     já morreu, e um 401 aqui dispararia refresh -> falha -> clearToLogin de
  //     novo, em laço;
  //   - token capturado na chamada e passado explícito, porque logo em seguida o
  //     `_resetAuthData` zera o default global do axios;
  //   - timeout curto: o logout não espera a rede.
  static async unregisterDevice (installationId, accessToken, timeoutMs = 2500) {
    const headers = accessToken ? { authorization: `bearer ${accessToken}` } : {};
    try {
      const response = await this.request({ auth: false }).delete(
        `${process.env.VUE_APP_EAD_API_URL}/students/devices/${encodeURIComponent(installationId)}`,
        { headers, timeout: timeoutMs }
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error, _errorMessage(error));
    }
  }

  // GET /students/push-preferences -> { replies, newContent, mutedCourses }
  static async getPreferences () {
    try {
      const response = await this.request({ auth: true }).get(
        `${process.env.VUE_APP_EAD_API_URL}/students/push-preferences`
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error, _errorMessage(error));
    }
  }

  // PUT /students/push-preferences -> 204. Campo ausente não muda; `mutedCourses`
  // presente é a lista COMPLETA.
  static async updatePreferences (patch) {
    try {
      const response = await this.request({ auth: true }).put(
        `${process.env.VUE_APP_EAD_API_URL}/students/push-preferences`,
        patch
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error, _errorMessage(error));
    }
  }

  // POST /students/push-events -> 204. Telemetria: `opened` | `received_fg`.
  static async postEvent (event, data) {
    try {
      const response = await this.request({ auth: true }).post(
        `${process.env.VUE_APP_EAD_API_URL}/students/push-events`,
        { event, data }
      );
      return new ResponseWrapper(response, response.data);
    } catch (error) {
      throw new ErrorWrapper(error, _errorMessage(error));
    }
  }
}

function _errorMessage (error) {
  return error.response?.data && typeof (error.response?.data) === 'object' ? error.response?.data.error : error.message
}
